import { Injectable } from '@angular/core';
import { getAngularJSService } from '../ng-upgrade.utils';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  // WRAPPER — substituir por ngx-toastr na Fase de Saída (FS.4)

  private readonly defaultHideDelay = 15000;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- services AngularJS sem tipos (§2.4); tipado na Exit Phase
  private $mdToast: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- constante AngularJS sem tipos (§2.4); tipado na Exit Phase
  private constService: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- service AngularJS sem tipos (§2.4); tipado na Exit Phase
  private $translate: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- $mdToast AngularJS sem tipos (§2.4); tipado na Exit Phase
  private get$mdToast(): any {
    if (this.$mdToast) return this.$mdToast;
    this.$mdToast = getAngularJSService('$mdToast');
    return this.$mdToast;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- CONST AngularJS sem tipos (§2.4); tipado na Exit Phase
  private getConst(): any {
    if (this.constService) return this.constService;
    this.constService = getAngularJSService('CONST');
    return this.constService;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- $translate AngularJS sem tipos (§2.4); tipado na Exit Phase
  private get$translate(): any {
    if (this.$translate) return this.$translate;
    this.$translate = getAngularJSService('$translate');
    return this.$translate;
  }

  private getHideDelay(): number {
    const CONST = this.getConst();
    return CONST?.TOAST_TIMEOUT ?? this.defaultHideDelay;
  }

  private translate(key: string, fallback: string): string {
    const $translate = this.get$translate();
    const translated = $translate?.instant(key);
    return translated && translated !== key ? translated : fallback;
  }

  private showToast(message: string, showClose = false): boolean {
    const $mdToast = this.get$mdToast();
    if (!$mdToast) {
      console.error('[ToastService] $mdToast não disponível.');
      return false;
    }

    const toast = $mdToast
      .simple()
      .textContent(message)
      .position('bottom right')
      .hideDelay(this.getHideDelay());
    if (showClose) {
      toast.action(this.translate('GENERIC.ACTIONS_CLOSE', 'FECHAR'));
    }

    $mdToast.show(toast);
    return true;
  }

  private notifyErrorFallback(message: string): void {
    // WRAPPER
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const notyf = (window as any).notyf;
    if (typeof notyf?.alert === 'function') {
      notyf.alert(message);
      return;
    }
    console.error('[ToastService] Falha ao exibir erro (notyf indisponível):', message);
  }

  success(message: string, showClose = true): void {
    this.showToast(message, showClose);
  }

  error(message: string, showClose = true): void {
    if (!this.showToast(message, showClose)) {
      this.notifyErrorFallback(message);
    }
  }

  info(message: string, showClose = true): void {
    this.showToast(message, showClose);
  }
}
